import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoginModel } from '../models/login-model';
import { Formule } from '../models/formule';
import { Session } from '../models/session';
import { Address } from '../models/address';
import { Abonnement } from '../models/abonnement';
import { catchError } from 'rxjs/operators';
import { dayInfo } from '../models/cdate';
import { Payment } from '../models/payment';
import { User } from '../micro-services/user/models/user';
import { UserCoach } from '../micro-services/user/models/user-coach';
import { ContactUs } from '../models/contact-us';
import { DeviceInfos } from '../models/device-infos';

type CreateUserType = {
  userName: string;
  phoneNumber: string;
  email: string;
  coachId: string;
  firstName : string;
  name : string;
  colorCode : string
};


@Injectable({
  providedIn: 'root'
})
export class ApiProviderService {

  private baseUrl: string = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getApiUrlCall(endUrl) {
    return this.baseUrl + endUrl;
  }

  login<T extends LoginModel>(loginModel: T): Observable<any> {
    const url = this.getApiUrlCall('api/authenticate/login');
    return this.http.post<any>(url, loginModel);
  }
  
  // Coach 

  createCoach(coach: User): Observable<any> {
    const url = this.getApiUrlCall("api/coaches");
    return this.http.post<any>(url, coach);
  }

  getCoach(id : string): Observable<UserCoach>{
    const url = this.getApiUrlCall(`api/Coaches/${id}`)
    return this.http.get<UserCoach>(url);
  }

  getCoaches(): Observable<User[]> {
    const url = this.getApiUrlCall("api/Coaches");
    return this.http.get<User[]>(url);
  }

  deleteCoach(coach: User): Observable<string> {
    const url = this.getApiUrlCall(`api/Coaches/${coach.id}`);
    return this.http.delete<string>(url);
  }

  editCoach(coach: User): Observable<any> {
    const url = this.getApiUrlCall(`api/Coaches/${coach.id}`);
    return this.http.put(url, coach);
  }

  getProfitsByMonthByCoach(idCoach: string, startDate: Date, endDate: Date) {
    const url = this.getApiUrlCall(`api/Coaches/ProfitByMonth/${idCoach}`);
    
    const params = new HttpParams()
      .set('startDate', startDate.toISOString().split('T')[0])
      .set('endDate', endDate.toISOString());

    const options = { params: params };

    return this.http.get(url, options);
  }

  getProfitsByMonthFormuleByCoach(idCoach: string, startDate: Date, endDate: Date) {
    const url = this.getApiUrlCall(`api/Coaches/ProfitByMonthFormule/${idCoach}`);
    
    const params = new HttpParams()
      .set('startDate', startDate.toISOString().split('T')[0])
      .set('endDate', endDate.toISOString());

    const options = { params: params };

    return this.http.get(url, options);
  }

  
  // Clients

  getUsers(): Observable<User[]> {
    const url = this.getApiUrlCall('api/Authenticate');
    return this.http.get<User[]>(url);
  }

  getSessionByCoachCalendar(id: string, dateStart: string, dateEnd): Observable<any> {
    const url = this.getApiUrlCall(`api/Sessions/getSessionByCoachCalendar`);
    const params = new HttpParams()
      .set('id', id)
      .set('dateStart', dateStart)
      .set('dateEnd', dateEnd);
    return this.http.get<any>(url, { params });
  }

  getUsersByCoach(id: string): Observable<User[]> {
    const url = this.getApiUrlCall(`api/Coaches/getUsersByCoach/${id}`);
    return this.http.get<User[]>(url,);
  }

  deleteClient(client: User): Observable<string> {
    const url = this.getApiUrlCall(`api/Clients/deleteClient/${client.id}`);
    return this.http.delete<string>(url);
  }

  createUser<T extends CreateUserType>(user: T): Observable<any> {
    const url = this.getApiUrlCall('api/Authenticate/register-client');
    return this.http.post<any>(url, user);
  }

  editClient(client: User): Observable<any> {
    const url = this.getApiUrlCall(`api/Clients/${client.id}`);
    return this.http.put(url, client);
  }

  // Formules

  getFormules(): Observable<Formule[]> {
    const url = this.getApiUrlCall("api/FormuleController");
    return this.http.get<Formule[]>(url);
  }

  getFormulesByCoach(id: string): Observable<Formule[]> {
    const url = this.getApiUrlCall(`api/Coaches/getFormulesByCoach/${id}`);
    return this.http.get<Formule[]>(url);
  }

  deleteFormule(formule: Formule): Observable<string> {
    const url = this.getApiUrlCall(`api/Formules/deleteFormule/${formule.id}`);
    return this.http.delete<string>(url);
  }

  createFormule(formule: Formule): Observable<any> {
    const url = this.getApiUrlCall("api/Formules/addFormule");
    return this.http.post<any>(url, formule);
  }

  editFormule(formule: Formule): Observable<any> {
    const url = this.getApiUrlCall(`api/Formules/putFormule/${formule.id}`);
    return this.http.put(url, formule);
  }

  getMostProfitFormule(coachId: string) {
    const url = this.getApiUrlCall(`api/Abonnement/Formule/MostProfit/${coachId}`)
    return this.http.get(url)
  }

  getMostUsedFormule(coachId: string) {
    const url = this.getApiUrlCall(`api/Abonnement/Formule/MostUsed/${coachId}`)
    return this.http.get(url)
  }

  getFormuleById(id: any) {
    const url = this.getApiUrlCall(`api/Formules/getFormule/${id}`)
    return this.http.get(url)
  }

  getProfitsByFormulesByCoach(idCoach: string, startDate: Date, endDate: Date) {
    const url = this.getApiUrlCall(`api/Formules/getProfitsByFormules/${idCoach}`);
    
    const params = new HttpParams()
      .set('startDate', startDate.toISOString().split('T')[0])
      .set('endDate', endDate.toISOString());

    const options = { params: params };

    return this.http.get(url, options);
  }

  //ABONNEMENT

  newAbonnementClient(abonnement: Abonnement) {
    const url = this.getApiUrlCall(`api/Abonnement`);
    return this.http.post(url, abonnement).pipe(
      catchError((error) => {
        console.error('Une erreur s\'est produite lors de la création de l\'abonnement:', error);
        return throwError('Une erreur s\'est produite lors de la création de l\'abonnement.');
      })
    );
  }

  getTotalProfit(coachId: string) {
    const url = this.getApiUrlCall(`api/Abonnement/TotalProfit/${coachId}`)
    return this.http.get(url)
  }

  getAbonnementByClient(clientId: string) {
    const url = this.getApiUrlCall(`api/Abonnement/Client/${clientId}`)
    return this.http.get(url)
  }

  activeOrDesacAbonnement(abonnement: Abonnement) {
    if (abonnement.isActive) {
      const url = this.getApiUrlCall(`api/Abonnement/Inactive/${abonnement.id}`)
      return this.http.put(url, abonnement)
    } else {
      const url = this.getApiUrlCall(`api/Abonnement/Active/${abonnement.id}`)
      return this.http.put(url, abonnement)
    }

  }

  //Payment 

  editPayment(payment : Payment){
    const url = this.getApiUrlCall(`api/payments/putPayment/${payment.id}` )
    return this.http.put(url, payment)
  }

  getPaymentsByClient(clientId : string){
    const url = this.getApiUrlCall(`api/payments/Client/${clientId}`)
    return this.http.get(url)
  }

  getPaymentsByClientByDate(clientId : string, startDate : Date, endDate : Date){
    const url = this.getApiUrlCall(`api/payments/Client/Date/${clientId}`)
    const params = new HttpParams()
      .set('startDate', startDate.toISOString())
      .set('endDate', endDate.toISOString());

    const options = { params: params };

    return this.http.get(url, options);
  }

  getLastPaymentsByCoach(coachId : string):Observable<Payment[]>{
    const url = this.getApiUrlCall(`api/payments/lastPayments/${coachId}`)
    return this.http.get<Payment[]>(url)
  }
  getPaymentsByCoach(coachId : string, page : number, size : number):Observable<Payment[]>{
    const url = this.getApiUrlCall(`api/payments/Coach/${coachId}/${page}/${size}`)
    return this.http.get<Payment[]>(url)
  }

  deletePayment(payment: Payment): Observable<number> {
    const url = this.getApiUrlCall(`api/payments/deletePayment/${payment.id}`);
    return this.http.delete<number>(url);
  }

  //SESSION 

  getSessionByCoach(coach: User): Observable<Session[]> {
    const url = this.getApiUrlCall(`api/Sessions/getSessionsByCoach/${coach.id}`);
    return this.http.get<Session[]>(url);
  }

  getNextSessionsByCoach(coach: User, date: string, page: number, pageSize: number): Observable<Session[]> {
    const url = this.getApiUrlCall(`api/Sessions/getNextSessionsByCoach/${coach.id}/${date}/${page}/${pageSize}`);
    return this.http.get<Session[]>(url);
  }

  getListOfDayPerSession(coach: User, date: string, page: number, pageSize: number): Observable<dayInfo[]> {
    const url = this.getApiUrlCall(`api/Sessions/getListOfDayPerSession/${coach.id}/${date}/${page}/${pageSize}`);
    return this.http.get<dayInfo[]>(url);
  }

  getPreviousSessionsByCoach(coach: User, date: string, page: number, pageSize: number): Observable<Session[]> {
    const url = this.getApiUrlCall(`api/Sessions/getPreviousSessionsByCoach/${coach.id}/${date}/${page}/${pageSize}`);

    return this.http.get<Session[]>(url);
  }

  isAlreadySession(session : Session) : Observable<Array<Session>>{
    const url = this.getApiUrlCall('api/Sessions/isAlreadySession');
    return this.http.post<Array<Session>>(url, session);
  }

  getSchedulesPerDay(coachId : string, date : string, duration : number) : Observable<Array<any>>{
    const url = this.getApiUrlCall(`api/Sessions/getSchedulesPerDay/${coachId}/${date}/${duration}`);
    return this.http.get<any>(url);
  }

  createSession(session: Session): Observable<Session>{
    const url = this.getApiUrlCall('api/Sessions');
    return this.http.post<Session>(url, session);
  }

  deleteSession(sesssion: Session): Observable<number> {
    const url = this.getApiUrlCall(`api/Sessions/${sesssion.id}`);
    return this.http.delete<number>(url);
  }

  editSession(session: Session): Observable<any> {
    const url = this.getApiUrlCall(`api/Sessions/${session.id}`);
    return this.http.put(url, session);
  }

  getSession(id : number) : Observable<Session>{
    const url = this.getApiUrlCall(`api/Sessions/${id}`);
    return this.http.get<any>(url);
  }

  getSessionsByCoachByClients(idCoach: string, idClient: string, date: string, page: number, pageSize: number, showFutureSessions: boolean = true): Observable<any[]> {
    let url = this.getApiUrlCall(`api/Sessions/getSessionsByCoachByClient/${idCoach}/${idClient}/${date}/${page}/${pageSize}/${showFutureSessions}`)
    return this.http.get<any[]>(url);
  }



  // ADDRESS REQUEST

  //FOR COACH 

  getAddressesByCoach(coach: User): Observable<Address[]> {
    const url = this.getApiUrlCall(`api/Adresses/getAddressesByCoach/${coach.id}`);
    return this.http.get<Address[]>(url);
  }

  createAddress(address: Address): Observable<Address> {
    const url = this.getApiUrlCall('api/Adresses');
    return this.http.post<Address>(url, address);
  }

  deleteAddress(address: Address): Observable<number> {
    const url = this.getApiUrlCall(`api/Adresses/${address.id}`);
    return this.http.delete<number>(url);
  }

  editAddress(address: Address): Observable<any> {
    const url = this.getApiUrlCall(`api/Adresses/${address.id}`);
    return this.http.put(url, address);
  }

  // FOR ADMIN
  getAddresses(): Observable<Address[]> {
    const url = this.getApiUrlCall('api/Adresses');
    return this.http.get<Address[]>(url);
  }

  // FIN ADDRESS REQUEST

  //Payment 

    //Par coach

    createPayment(payment: Payment){
      const url = this.getApiUrlCall('api/payments/createPayment');
      return this.http.post<Payment>(url, payment);
    }


    stripePortal() : Observable<any>{
      const url = this.getApiUrlCall('api/Stripe/customer-portal');
      return this.http.post<Payment>(url, {});
    }


  //METHODE GENERIQUE car l'api provider commence a etre long LOL 

    // 🔹 Méthode générique pour tous les appels API
    request<T>(method: 'GET' | 'POST' | 'PUT' | 'DELETE', endpoint: string, data?: any): Observable<T> {
      const url = `${this.baseUrl+"api/"}${endpoint}`;
  
      switch (method) {
        case 'GET':
          return this.http.get<T>(url);
        case 'POST':
          return this.http.post<T>(url, data);
        case 'PUT':
          return this.http.put<T>(url, data);
        case 'DELETE':
          return this.http.delete<T>(url);
        default:
          throw new Error('Méthode HTTP non supportée');
      }
    }




    // DEBUT USER

  contactUs(contact : ContactUs): Observable<any> {
    const url = this.getApiUrlCall("api/Users/ContactUs");
    return this.http.post<any>(url, contact);
  }


    // FIN USER


    // DEBUT FIREBASE 

      createFirebaseToken(firebase  : DeviceInfos){
        const url = this.getApiUrlCall(`api/Firebase/createDeviceInfos`);
        return this.http.post<boolean>(url, firebase);
      }

      updatefirebaseToken(firebase : DeviceInfos){
        const url = this.getApiUrlCall(`api/Firebase/updateDeviceInfos`);
        return this.http.put<boolean>(url, firebase);
      }

    // END FIREBASE
}
